import React from 'react';
import UserCard from 'components/users/UserCard';
import { ResourceCardElement } from 'components/ResourceCardElements';
import IQMType from 'types/iqm';
import { stringifyList } from '../../../../../utils';

const IQMCard = ({ iqm }) =>
  <UserCard user={iqm} type="iqms">
    <ResourceCardElement
      title="Workroom(s)"
      size="small"
      value={stringifyList(iqm.workrooms) || 'No Workroom'}
    />
    <ResourceCardElement
      title="Surface Type(s)"
      size="small"
      value={stringifyList(iqm.surface_types) || 'No Surface Type'}
    />
  </UserCard>;

IQMCard.propTypes = {
  iqm: IQMType.isRequired,
};

export default IQMCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/components/IQMCard.jsx